module.exports = __webpack_public_path__ + "media/images/shop/icon-rectangle-04142acf784b8263dfabc7db0a55127a.svg";